export const TableHeadClasses = () => {
  return {
    base: {
      common: 'align-middle relative',
      ios: 'hairline-b',
      material: ''
    }
  };
};